class cSearchBox {
    constructor(selector) {
        this.cSearchBoxElement = document.querySelector(selector);
        if (!this.cSearchBoxElement) return;

        this.noDestination = parseInt(this.cSearchBoxElement.dataset.noDestination || 0);

        this.body = document.body;

        this.searchDisabled = false;
        this.cSearchBoxFormElement = this.cSearchBoxElement.querySelector(".c-search-value-container form");
        this.cSearchBoxInputElement = this.cSearchBoxElement.querySelector(".c-search-value-container input");
        this.cSearchBoxDropdownElement = this.cSearchBoxElement.querySelector(".c-search-menu");
        this.cSearchBoxDropdownItems = this.cSearchBoxDropdownElement?.querySelectorAll(".c-search-menu-item-button-container");
        this.cSearchBoxCloseButton = this.cSearchBoxElement.querySelector(".c-search-close-icon");
        this.cSearchBoxControlStyle = this.cSearchBoxElement.querySelector(".c-search-control-style");
        this.cSearchBoxStartYourSearch = this.cSearchBoxElement.querySelector("#c-start-your-search");
        this.cSearchBoxSelectDates = this.cSearchBoxElement.querySelector("#c-select-dates");
        this.cSearchBoxSelectDatesCalendar = null;
        this.inputPlaceofActivity = this.cSearchBoxElement.querySelector("#c-place-or-activity input");
        this.searchAjax = {abort: function () {}};
        this.mobileSearchButton = this.body.querySelector('.mobile-search-button-right button');

        this.wasPlaceOrActivityModalOpened = false;

        this.isMobile = false;

        if(this.inputPlaceofActivity) {
            this.isMobile = true;

            this.startYourSearchModal = new cSearchModal('#c-start-your-search');
            this.placeOrActivityModal = new cSearchModal('#c-place-or-activity', false, () => this.placeOrActivityModalHideCallBack(), () => this.placeOrActivityModalShowCallBack());
            this.selectDatesModal = new cSearchModal('#c-select-dates');
        }

        this.init();
    }

    init() {
        if (!this.cSearchBoxElement) return;

        window.coolData = window.coolData || [];

        this.cSearchBoxCloseButton?.addEventListener("click", () => this.hide());

        document.addEventListener("click", (event) => {
            if (!this.cSearchBoxElement.contains(event.target)) {
                this.hide();
            }
        });

        if (this.cSearchBoxDropdownItems) {
            this.cSearchBoxDropdownItems.forEach(item => {
                const button = item.querySelector("button[data-url]");
                button?.addEventListener("click", () => {
                    const url = button.dataset.url;
                    if (url) window.location.href = url;
                });
            });
        }

        if(this.isMobile) {

            this.cSearchBoxControlStyle?.addEventListener("click", (e) => {
                //e.stopPropagation();
                if (window.innerWidth <= 1025) {

                    if(this.noDestination && !this.wasPlaceOrActivityModalOpened) {
                        this.wasPlaceOrActivityModalOpened = true;
                        this.placeOrActivityModal.show();
                    }
                    else {
                        this.startYourSearchModal.show();
                    }
                }
            });

            this.mobileSearchButton?.addEventListener("click", (e) => {
                //e.stopPropagation();
                if (window.innerWidth <= 1025) {

                    if(!this.wasPlaceOrActivityModalOpened) {
                        this.wasPlaceOrActivityModalOpened = true;
                        this.placeOrActivityModal.show();
                    }
                    else {
                        this.startYourSearchModal.show();
                    }
                }
            });
        }

        this.setupSearch();


        if (this.cSearchBoxStartYourSearch) {
            this.cSearchBoxStartYourSearch.querySelector(".c-search-for-place-or-activity")?.addEventListener("click", (e) => {
                e.stopPropagation();
                this.placeOrActivityModal.show();
            });

            let cSearchDatesPage = this.cSearchBoxSelectDates;
            let cSearchPage = this.cSearchBoxStartYourSearch;
            let that = this;

            if (  !cSearchDatesPage.querySelector(".lightpick") ){
                const cDatePickerInput = cSearchDatesPage.querySelector("#c_datepicker");

                let startDate = tmVisitorStore.getSavedStartDate();
                let endDate = tmVisitorStore.getSavedEndDate();

                this.cSearchBoxSelectDatesCalendar = new Lightpick(
                    {
                        field: cDatePickerInput,
                        inline: true,
                        singleDate: false,
                        footer: true,
                        minDate: moment(),
                        format: 'YYYY-MM-DD',
                        numberOfMonths: parseInt(1),
                        dropdowns: false,
                        orientation: 'bottom',
                        startDate: startDate,
                        endDate: endDate,
                        locale: {
                            buttons: {
                                prev: '<i class="fa-solid fa-chevron-left"></i>',
                                next: '<i class="fa-solid fa-chevron-right"></i>',
                                reset: 'Reset',
                                apply: 'Apply',
                            },
                        },
                        onSelect: function(start, end){
                            tmVisitorStore.saveSelectedDates(start?.format('YYYY-MM-DD'), end?.format('YYYY-MM-DD'));

                            if(start == null && end == null) {
                                window.coolData['startDate'] = null;
                                window.coolData['endDate'] = null;
                                this.hide();
                            }
                        },
                        onClose: function(){
                            that.populateDateLabels();
                            cSearchDatesPage.querySelector(".c-search-modal-close-button").click();
                        },
                        onOpen: function() {
                            fixDatePickerStyling();
                        }
                    }
                );

                attachNewArrowsEvents(this.cSearchBoxSelectDatesCalendar);

                const searchDatesResetAction = cSearchDatesPage.querySelector('.lightpick__footer .lightpick__reset-action');
                const searchDatesApplyAction = cSearchDatesPage.querySelector('.lightpick__footer .lightpick__apply-action');

                searchDatesResetAction.classList.add("c-btn","c-btn-ghost");
                searchDatesApplyAction.classList.add("c-btn");
            }

            this.cSearchBoxStartYourSearch.querySelector(".c-search-dates")?.addEventListener("click", (e) => {
                e.stopPropagation();

                new cSearchModal("#c-select-dates", true);

                this.cSearchBoxSelectDatesCalendar.show();
            });

            this.populateDateLabels();
        }
    }

    populateDateLabels() {
        let datePicker = this.cSearchBoxSelectDatesCalendar;
        if(datePicker && datePicker.getStartDate()) {
            let startDate = datePicker.getStartDate().format('MMM DD');
            let endDate = '';
            let inputDate = startDate;

            if ( datePicker.getEndDate() ){
                endDate = datePicker.getEndDate().format('MMM DD');
            }

            if ( ( startDate != endDate ) && endDate.length > 0 ){
                inputDate = startDate + " - " + endDate;
            }
            this.cSearchBoxStartYourSearch.querySelector(".c-search-dates input").value = inputDate;

            if(this.cSearchBoxElement.querySelector('.c-search-date-wrapper[data-date="yes"]')) {
                this.cSearchBoxElement.querySelector('.c-search-date-wrapper[data-date="yes"] > span:first-child').textContent = '•';
                this.cSearchBoxElement.querySelector(".c-search-date-text").textContent = inputDate;
                this.cSearchBoxElement.querySelector(".c-search-date-text").classList.remove("good-color-txt-color");
                this.cSearchBoxElement.querySelector(".c-search-date-text").classList.remove("c-txt-bold");
            }
        }
        else {
            this.cSearchBoxStartYourSearch.querySelector(".c-search-dates input").value = '';
        }
    }

    setupSearch() {
        this.cSearchBoxElement.addEventListener('click', (event) => {
            let buttonClicked = event.target.closest('.c-search-menu-item-button');

            if(buttonClicked && buttonClicked.dataset.url) {


                if(this.isMobile) {
                    let input = this.cSearchBoxStartYourSearch.querySelector('.c-search-for-place-or-activity input');

                    if(input) {
                        if(buttonClicked.dataset.url == 'javascript:void(0)') {
                            input.value = this.inputPlaceofActivity.value;
                        }
                        else {
                            input.value = buttonClicked.querySelector('.c-search-menu-item-button-title')?.textContent?.trim();
                        }

                        input.dataset.url = buttonClicked.dataset.url;
                    }
                    this.placeOrActivityModal.hide();
                    this.startYourSearchModal.show();
                }
                else {
                    if(buttonClicked.dataset.url == 'javascript:void(0)') {
                        this.cSearchBoxInputElement.closest('form')?.submit();
                    }
                    else {
                        window.location.href = buttonClicked.dataset.url;
                    }
                }
            }
        });


        if(this.inputPlaceofActivity) {
            this.inputPlaceofActivity?.addEventListener('keyup', this.search.bind(this));
        }
        else if(this.cSearchBoxInputElement) {
            this.cSearchBoxInputElement?.addEventListener("click", () => {
                if(this.cSearchBoxElement.querySelectorAll('.c-search-menu-css > div').length) {
                    this.show()
                }
                else {
                    if(this.cSearchBoxInputElement.value) {
                        this.cSearchBoxInputElement.dispatchEvent(new KeyboardEvent('keyup',{'key':'a'}))
                    }
                }
            });

            this.cSearchBoxInputElement.addEventListener('keyup', this.search.bind(this));
        }

        if(this.cSearchBoxStartYourSearch) {
            this.cSearchBoxStartYourSearch.querySelector('.c-search-modal-content button')?.addEventListener('click', (event) => {
                let input = this.cSearchBoxStartYourSearch.querySelector('.c-search-for-place-or-activity input');

                if(input.dataset.url) {
                    if(input.dataset.url == 'javascript:void(0)') {
                        this.cSearchBoxInputElement.value = input.value;
                        if(this.cSearchBoxInputElement.value != '') {
                            this.cSearchBoxInputElement.closest('form')?.submit();
                        }
                    }
                    else {
                        window.location.href = input.dataset.url;
                    }
                }
            });
        }

        if(this.cSearchBoxFormElement) {
            this.cSearchBoxElement.addEventListener('submit', (event) => {
                this.searchDisabled = true;
                let exactMatchElement = this.cSearchBoxElement.querySelector('[data-exact-match="1"]');

                if(exactMatchElement && exactMatchElement.dataset && exactMatchElement.dataset.url) {
                    event.preventDefault();
                    event.stopPropagation();
                    window.location.href = exactMatchElement.dataset.url;
                }
            });
        }
    }

    search(event) {
        if(this.searchDisabled) {
            return;
        }
        clearTimeout(this.timerId);

        this.timerId = setTimeout(function(){
            //console.log(event)
            let data = {
                'action': 'search_form',
                'search_text': event.target.value,
                'newTemplateDesign': 1
            };

            this.searchAjax.abort();

            if(this.isMobile) {
                this.inputPlaceofActivity.nextElementSibling?.classList.add('c-hidden');
                this.inputPlaceofActivity.parentElement.querySelector('.c-loader-wrapper')?.classList.remove('c-hidden');
            }else{
                this.cSearchBoxInputElement.parentElement.querySelector('.c-input-control-icon')?.classList.add('c-hidden');
                this.cSearchBoxInputElement.parentElement.querySelector('.c-loader-wrapper')?.classList.remove('c-hidden');
            }

            this.searchAjax = jQuery.post(ajaxurl, data, function(response) {
                jQuery(this.cSearchBoxElement.querySelector('.c-search-menu')).replaceWith(response);
                jQuery(document).trigger('searchResultsUpdated');

                if(this.isMobile) {
                    jQuery(this.cSearchBoxElement.querySelector('.c-search-menu')).addClass('show');
                    this.inputPlaceofActivity.nextElementSibling?.classList.remove('c-hidden');
                    this.inputPlaceofActivity.parentElement.querySelector('.c-loader-wrapper')?.classList.add('c-hidden');
                }
                else {
                    this.show();
                    this.cSearchBoxInputElement.parentElement.querySelector('.c-input-control-icon')?.classList.remove('c-hidden');
                    this.cSearchBoxInputElement.parentElement.querySelector('.c-loader-wrapper')?.classList.add('c-hidden');
                }
            }.bind(this));
        }.bind(this), 200);
    }

    show() {
        this.cSearchBoxElement?.classList.add("show");
        if ( typeof window.avatarMenu === 'object' ){
            window.avatarMenu.hide();
        }
        if ( typeof window.languageDropdownMenu === 'object' ){
            window.languageDropdownMenu.hide();
        }
    }

    hide() {
        this.cSearchBoxElement?.classList.remove("show");
    }

    placeOrActivityModalHideCallBack() {
        this.startYourSearchModal.show();
    }

    placeOrActivityModalShowCallBack() {
        let hasResults = this.cSearchBoxElement.querySelectorAll('.c-search-menu-css > div').length;

        if(!hasResults && this.inputPlaceofActivity.value) {
            this.inputPlaceofActivity.dispatchEvent(new KeyboardEvent('keyup',{'key':'a'}))
        }

        const inputIcon = this.inputPlaceofActivity?.nextElementSibling;

        if (this.inputPlaceofActivity) {
            this.inputPlaceofActivity.focus();
            this.cSearchBoxDropdownElement?.classList.add("show");
        }

        if (inputIcon) {
            inputIcon.style.display = "block";
            inputIcon.addEventListener("click", (e) => {
                e.stopPropagation();
                inputIcon.style.display = "none";
                this.inputPlaceofActivity.value = "";
                this.inputPlaceofActivity.focus();
            });
        }
    }
}
